<!-- UI-5 (5e): shared header bar for viewer flyout panels (design .flyout .hd):
     panel title + optional sub-label + a close button that turns red on hover. -->
<template>
  <div class="flyout-hd">
    <span class="flyout-title">
      {{ title }}<span v-if="sub" class="flyout-sub">{{ sub }}</span>
    </span>
    <button class="flyout-x" :title="$t('button-close')" @click="$emit('close')">
      <i class="fas fa-times"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'flyout-header',
  props: {
    title: {type: String, default: ''},
    sub: {type: String, default: ''}
  }
};
</script>

<style scoped>
.flyout-hd {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -0.85em -1em 0.75em;
  padding: 11px 12px 9px;
  border-bottom: 1px solid #e5e8ee;
}

.flyout-title {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: #0e1116;
  letter-spacing: -0.01em;
}

.flyout-sub {
  font-size: 11px;
  color: #5a6172;
  font-weight: 400;
  margin-left: 6px;
}

.flyout-x {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  border-radius: 4px;
  color: #8a91a1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flyout-x:hover {
  background: #fbeae9;
  color: #c8443c;
}
</style>
